import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getMe: () => ({
    url: `User/api/v1/user/me`,
    method: 'GET',
  }),
  getCompleteRegisterUrl: (input) => ({
    url: `User/api/v2/user/RegisterComplete`,
    method: 'POST',
    data: input,
  }),
  getFinexUserCode: () => ({
    url: `User/api/v1/User/UserCode`,
    method: 'GET',
  }),
  submitFinexUserCode: (input) => ({
    url: `User/api/v1/User/UserCode`,
    method: 'POST',
    data: input,
  }),
  getCustomerRegState: (input) => ({
    url: '/user/api/v2/user/RegState',
    method: 'GET',
    params: input,
  }),
  submitFireBaseToken: (input) => ({
    url: '/User/api/v1/User/FireBaseToken',
    method: 'POST',
    data: input,
  }),
  login: (input) => ({
    url: '/user/anonymous/api/v1/identity/login',
    method: 'POST',
    data: input,
  }),
  logoutToken: () => ({
    url: '/user/api/v1/user/LogoutToken',
    method: 'POST',
  }),
  logoutSession: (input) => ({
    url: '/user/api/v1/user/LogoutSession',
    method: 'POST',
    data: input,
  }),
  logoutAll: () => ({
    url: '/user/api/v1/user/LogoutAll',
    method: 'POST',
  }),
  verifyLogin: (input) => ({
    url: '/user/anonymous/api/v1/identity/VerifyLogin',
    method: 'POST',
    data: input,
  }),
  sendForgetPasswordOtp: (input) => ({
    url: '/user/Anonymous/api/v1/forgetPassword/sendOtp',
    method: 'POST',
    data: input,
  }),
  verifyForgetPasswordOtp: (input) => ({
    url: '/user/anonymous/api/v1/forgetPassword/verifyForgetPassword',
    method: 'POST',
    data: input,
  }),
  updatePassword: (input) => ({
    url: '/user/anonymous/api/v1/forgetPassword/updateForgetPassword',
    method: 'POST',
    data: input,
  }),
  getActiveDevices: () => ({
    url: '/user/api/v1/sessionManagement/devices',
    method: 'GET',
  }),
  getSessionHistory: () => ({
    url: '/user/api/v1/sessionManagement/history',
    method: 'GET',
  }),
  addSession: (input) => {
    return {
      url: '/user/api/v2/sessionManagement',
      method: 'POST',
      data: input,
    };
  },
  initSession: () => {
    return {
      url: '/user/api/v1/user/initSession',
      method: 'POST',
    };
  },
};

export default apis;
